import EventBus from 'js-event-bus';

const eventBus = new EventBus();
window.eventBus = eventBus;

export default eventBus;
